module.exports = "https://s91588.cdn.ngenix.net/cs-frontend-v2/_next/static/images/AgreementSigned-f19493f63d0b5a97f49b771c90a8e6ab.png";